"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCourierNameFromElement = getCourierNameFromElement;
function getCourierNameFromElement(element) {
  if (!(element instanceof Element)) {
    return undefined;
  }
  const elementWithData = element.closest('[data-courier-name]');
  if (!(elementWithData instanceof Element)) {
    return undefined;
  }
  const {
    dataset: {
      courierName
    }
  } = elementWithData;
  return courierName;
}